<template>
  <div class="container_box">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/union/:id', query: { id: unionId } }">联盟生态</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/trainList', query: { id: unionId } }">培训列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{detail.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_left">
      <div class="text_detail_box">
        <div class="text_detail_title">
          <p>{{detail.title}}</p>
          <p class="text_detail_time">发布时间：{{detail.add_time}}</p>
          <p class="text_detail_tag">标签：
            <span v-for="item in detail.tag" :key="item.id">{{item.tag_name}}</span>
          </p>
        </div>
        <div v-if="childOnOff && detail.video_path.length > 0" class="text_detail_video">
          <video-view :src-arr="detail.video_path" :bg-img="detail.bg_img_path"></video-view>
        </div>
        <div class="text_detail_content" v-html="detail.content"></div>
        <div class="expert_list_other rt">
          <share-view :detail="detail"></share-view>
        </div>
      </div>
      <comment-view
      :comments = "comment"
      :list-id = "commentList.list_id"
      :user = "user"
      :mescount = "detail.mes_count"
      :participatecount = "detail.participate_count"
      ></comment-view>
    </div>
    <div class="glag_right">
      <recommend-view v-if="recommendList !== null" :list="recommendList"></recommend-view>
    </div>
  </div>
</template>

<script>
import video from '../Public/video.vue'
import comment from '../Public/comment.vue'
import recommend from '../Public/detailRecommendList.vue'
import share from '../Public/share.vue'
export default {
  components: {
    videoView: video,
    commentView: comment,
    recommendView: recommend,
    shareView: share
  },
  data () {
    return {
      unionId: '',
      childOnOff: false, // 子组建渲染开关
      commentList: {
        list_id: '',
        sort: 1 // 评论排序：1热度查询，时间查询
      },
      detail: {}, // 文章详情
      user: {}, // 作者信息
      comment: {
        comments: []
      }, // 评论列表
      recommendList: null // 相关内容推荐
    }
  },
  created () {
    const vueThat = this
    vueThat.commentList.list_id = vueThat.$route.query.id
    vueThat.getDetail()
  },
  methods: {
    // 获取详情信息
    getDetail () {
      const vueThat = this
      vueThat.myApi.getTrainDetails({ list_id: vueThat.commentList.list_id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.childOnOff = true
          vueThat.detail = res.data.data.data
          vueThat.unionId = res.data.data.data.union_id
          vueThat.comment.comments = res.data.data.mes_data
          vueThat.recommendList = res.data.data.right
          vueThat.user = res.data.data.right.user
        }
      })
    }
  }
}
</script>

<style>
</style>
